<template>
  <v-menu
    v-model="menuNotifications"
    :close-on-content-click="false"
    :nudge-width="400"
    min-width="35vw"
    max-width="60vw"

  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" :disabled="notifications.length < 1" text>
        <v-badge
          :content="unreadNotifications.length"
          :value="unreadNotifications.length"
          color="orange"
          overlap
          left
        >
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-list>
      <v-list-item-group>
        <template>
          <div
            v-for="(notification, index) in notifications"
            :key="`notificationcontent-${index}`"
          >
            <v-list-item
              @click="markReaded(notification)"
              class="pt-3 pb-3"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <v-badge
                          dot
                          offset-x="10"
                          offset-y="10"
                          style="margin-top:0 !important;"
                          :color="(notification.status === 'unread')?'red':'transparent'"
                          class="mr-4"
                  >
                    <v-icon
                            v-if="icons[notification.type] !== undefined"
                            :color="icons[notification.type].color"
                    >
                      {{ icons[notification.type].icon }}
                    </v-icon>
                  </v-badge>

                  <span>
                    {{
                    $t(
                    "notifications.messages." + notification.message,
                    notification.message_data
                    )
                  }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-divider
            style="margin:0;"
          ></v-divider>
        </template>
        <v-list-item
          key="notificationcontent-markasread"
          @click="cleanAllReaded"
          class="pt-2 pb-2"
        >
          <v-list-item-content class="text-center">
            <v-list-item-title>
              <v-badge
                      dot
                      offset-x="10"
                      offset-y="10"
                      style="margin-top:0 !important;"
                      color="transparent"
                      class="mr-4"
              >
                <v-icon
                      color="orange"
                >
                  mdi-broom
                </v-icon>
              </v-badge>

              <span>
                {{ $t("notifications.actions.deleteAll") }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      polling: null,
      menuNotifications: false,
      notifications: [],
      unreadNotifications: [],
      icons: {
        investigatorformprocessed: {
          icon: "mdi-check-circle",
          color: "green"
        },
        investigatorformrejected: {
          icon: "mdi-close-octagon",
          color: "red"
        },
        publicationformprocessed: {
          icon: "mdi-check-circle",
          color: "green"
        },
        publicationformrejected: {
          icon: "mdi-close-octagon",
          color: "red"
        },
        projectformprocessed: {
          icon: "mdi-check-circle",
          color: "green"
        },
        projectformrejected: {
          icon: "mdi-close-octagon",
          color: "red"
        },
        newsformprocessed: {
          icon: "mdi-check-circle",
          color: "green"
        },
        newsformrejected: {
          icon: "mdi-close-octagon",
          color: "red"
        },
        stayformprocessed: {
          icon: "mdi-check-circle",
          color: "green"
        },
        stayformrejected: {
          icon: "mdi-close-octagon",
          color: "red"
        },
        pendingvalidateforms: {
          icon: "mdi-clipboard-search-outline",
          color: "blue"
        },
        pendingprocessforms: {
          icon: "mdi-clipboard-arrow-right-outline",
          color: "blue"
        },
        pendingsingforms: {
          icon: "mdi-draw",
          color: "orange accent-4"
        },
        expireaccount: {
          icon: "mdi-account-clock",
          color: "orange accent-4"
        },
        expireworkplace: {
          icon: "mdi-garage-alert",
          color: "orange accent-4"
        },
        expirevinculation: {
          icon: "mdi-calendar-clock",
          color: "orange accent-4"
        },
        pendingvalidatepublication: {
          icon: "mdi-book-clock",
          color: "orange accent-4"
        }
      }
    };
  },

  created() {
    if(this.$store.state.isInternal){
      this.getUserNotifications();
      this.pollData();
    }
  },

  beforeDestroy() {
    clearInterval(this.polling);
  },

  methods: {
    pollData() {
      this.polling = setInterval(() => {
        this.getUserNotifications();
      }, 60000);
    },
    getUserNotifications() {
      let path = this.$store.state.endpoint + "/notification/user";
      axios
        .get(path)
        .then(response => {
          this.notifications = response.data;
          this.unreadNotifications = this.notifications.filter(item => item.status === "unread");
        })
        .catch(error => {
          console.log(error);
          clearInterval(this.polling)
        });
    },
    cleanAllReaded() {
      axios
        .patch(this.$store.state.endpoint + "/notification/user/clean")
        .then(response => {
          this.notifications = response.data;
          if (!this.notifications.length) {
            this.menuNotifications = false;
          }
        });
    },
    markReaded(notification) {
      this.$router.push(notification.link);
      axios
        .patch(
          this.$store.state.endpoint + "/notification/read/" + notification.id
        )
        .then(response => {
          this.notifications.find(not => not.id === notification.id).status =
            response.data.status;
          this.unreadNotifications = this.notifications.filter(item => item.status === "unread");
          this.menuNotifications = false;
        })
        .catch(error => console.log(error));
    }
  }
};
</script>
